
import { h } from 'preact';
import cx from 'classnames';
import { Row, Column } from '@cube/layout';
import { LinkEventList } from '../../linkevent';
import style from './style.less';
import Copyright from '../../copyright';
import { withConfig } from '../../../config';
import { TrackingProvider, DIMENSION } from '@cube/track';

function Footer({ links = [], altLinks = [], affiliateLinks = [], class: cls }) {
	return (
		<TrackingProvider {...{
			[DIMENSION.componentpath]: 'MobileFooter'
		}}
		>
			<Row class={cx(style.footer, cls)}>
				<Column class="col-12">
					<Row>
						<Column class={style.legal}>
							<TrackingProvider {...{
								[DIMENSION.componentpath]: 'Links'
							}}
							>
								<LinkEventList
									links={[...links, ...altLinks]}
									handleEvent={this.handleEvent}
									class={style.footerLinks}
								/>
							</TrackingProvider>
						</Column>

						<Column class={cx('col-12', style.affiliate)}>
							<TrackingProvider {...{
								[DIMENSION.componentpath]: 'AffiliateLinks'
							}}
							>
								<LinkEventList
									links={affiliateLinks}
									handleEvent={this.handleEvent}
								/>
							</TrackingProvider>
						</Column>

						<Column class={cx('col-12', style.copyright)}>
							<Copyright />
						</Column>
					</Row>
				</Column>
			</Row>
		</TrackingProvider>
	);
}

const FooterConfig = withConfig([
	'headerWidget.theme',

	'headerWidget.mobile.footer.links',
	'headerWidget.footer.links',

	'headerWidget.mobile.footer.altLinks',
	'headerWidget.footer.altLinks',

	'headerWidget.mobile.footer.affiliateLinks',
	'headerWidget.footer.affiliateLinks'

])(Footer);

export default FooterConfig;
